import {useI18n} from "../i18n/I18nProvider";
export function ExperienceSourceLink({url}:{url?:string}){
 const {language}=useI18n();
 if(!url||!/^https:\/\//.test(url)||url.includes("openstreetmap.org"))return null;
 return <a className="experience-source-link" href={url} target="_blank" rel="noopener noreferrer">{language==="it"?"Programma e dettagli":language==="es"?"Programa y detalles":"Programme and details"}</a>;
}
